'use client'

import React, { ReactNode } from 'react'
import BaseModal from '@/components/Refresh/Modals/BaseModal/BaseModal'

interface InactivityModalProps {
    opened: boolean
    onClose: () => void
    zIndex?: number
    children: ReactNode
}

export default function InactivityModal({ opened, onClose, zIndex = 1000, children }: InactivityModalProps) {
    return (
        <BaseModal opened={opened} onClose={onClose} zIndex={zIndex}>
            {children}
        </BaseModal>
    )
}
